import script from "./PGTextSelectionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PGTextSelectionButton.vue?vue&type=script&setup=true&lang=js"

import "./PGTextSelectionButton.vue?vue&type=style&index=0&id=0b8c3e29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8c3e29"]])

export default __exports__